import axios from "axios";
import { ip_back } from "../../config";

const getToken = () => localStorage.getItem("token");

const headers = () => ({
  headers: { Authorization: getToken() },
});

/**
 * Send a message to the SmartTT-Coach
 * @param {string} message - User message
 * @param {string|null} conversationId - Conversation ID for context
 * @param {object} context - Optional context (ts_id, language, club_id)
 * @param {object} [options] - Optional { input_mode: 'text'|'voice' }
 * @returns {Promise<{message: string, conversationId: string}>}
 */
export const sendMessage = async (message, conversationId = null, context = {}, options = {}) => {
  try {
    const payload = { message, conversationId, context: { ...context } };
    if (options.input_mode) {
      payload.input_mode = options.input_mode;
    }
    if (Number.isFinite(options.rewindCompleteTurns) && options.rewindCompleteTurns >= 0) {
      payload.context.rewindCompleteTurns = options.rewindCompleteTurns;
    }
    const response = await axios.post(
      `${ip_back}api/ai-coach/chat`,
      payload,
      headers()
    );
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 429) {
      throw new Error("Digiping is temporarily busy. Please try again in a moment.");
    }
    throw new Error(error.response?.data?.message || "Failed to communicate with Digiping.");
  }
};

/**
 * Clear the conversation history
 * @param {string} conversationId
 */
export const clearConversation = async (conversationId) => {
  try {
    await axios.post(
      `${ip_back}api/ai-coach/clear`,
      { conversationId },
      headers()
    );
  } catch (error) {
    // Silent fail on clear
    console.warn("Failed to clear conversation:", error.message);
  }
};

/**
 * Check SmartTT-Coach availability
 */
export const checkStatus = async () => {
  try {
    const response = await axios.get(`${ip_back}api/ai-coach/status`, headers());
    return response.data.data?.available || false;
  } catch {
    return false;
  }
};
